import {
  SearchBillableItemsResponse,
  CursorSearch,
} from './src/billable-items-v1-billable-item-billable-items.universal';

export * from './src/billable-items-v1-billable-item-billable-items.universal.js';

/** @hidden */
export type BillableItemSearch = {};

/**
 * Retrieves a list of up to 100 billable items, given the specified filtering, search expression, sorting, and cursor paging.
 *
 * Learn more about [API query language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language).
 * @param search - Search options.
 * @public
 * @requiredField search
 * @permissionId BILLABLE_ITEMS.BILLABLE_ITEM_READ
 * @applicableIdentity APP
 * @fqn wix.billable_items.v1.BillableItems.SearchBillableItems
 */
export declare function searchBillableItems(
  search: CursorSearch
): Promise<SearchBillableItemsResponse>;
